export const sharedTransition = {
  duration: 0.3,
  ease: 'easeOut',
};
